// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:16
import { Field_abstract } from './../abstract/SagaBase/Field_abstract';
export class Field extends Field_abstract {}
